var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoveaaiLogoDarkText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4032.98 892.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#e9006d;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#fff;}.cls-4{fill:url(#radial-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#radial-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 429.97,
    y1: 717.35,
    x2: 601.97,
    y2: 345.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f0d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0c1132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0b143f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c3d9c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 69.6,
    cy: 346.91,
    fx: 69.6,
    fy: 346.91,
    r: 586.1,
    gradientTransform: "translate(-29.14 118.14) rotate(-7.13) scale(1 .69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21d0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#17b8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#0a96e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#068adf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0481dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0269d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0057ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.11,
    y1: 293.65,
    x2: 684.54,
    y2: 300.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7036b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7633bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7e31ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#371a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#311766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#23114e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0b0728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080623"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 141.6,
    cy: 220.92,
    fx: 141.6,
    fy: 220.92,
    r: 552.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41197e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#3c1777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#311364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1e0d46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 152.51,
    y1: 386.08,
    x2: 545.25,
    y2: 386.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#121827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0d0f1b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m7.86,480.42c-20.96-96.37,6.85-198.54,19.58-227.64,14.16-32.36,44.66-88.79,105.61-136.42,19.36-15.13,70.16-51.53,145.99-67.27,97.55-20.26,175.87,6.25,204.08,17.28,22.4,8.76,128.82,52.99,188.66,169.24,30.47,63.36,36.3,118.29,39.08,158.32.23,16.59-.3,61.22-17.37,115.37-8.06,25.58-27.96,86.4-81.83,141.97-71.92,74.19-158.52,91.71-183.28,96.36-178.04,33.47-309.87-86.44-318.71-94.74-29.54-27.79-79.92-84.85-101.83-172.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m624.5,476.31c-16,117-125.01,282.56-370.51,260.78h0c141.49,45.39,282.12-5.98,361.51-89.78,108-114,39.05-245.78,39.05-245.78-20.78-40.58-44.62-73.23-69.91-99.48,21.49,35.09,50.24,98.35,39.86,174.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m543.08,352.94c16.66,131.75-65.87,196.87-129.58,216.37,0,0-96,46-246-42C17.5,439.31,27.5,251.31,27.5,251.31c0,0-98,236,76,396,48.39,44.5,99.5,73.42,150.49,89.78h0c245.49,21.78,354.51-143.78,370.51-260.78,10.38-75.9-18.38-139.17-39.86-174.26-56.93-59.1-121.2-85.74-174.48-97.2,120.04,38.18,132.93,148.08,132.93,148.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m665.5,223.31C583.5,69.31,377.5-4.69,203.5,73.31S-6.5,335.31,135.5,473.31c38.52,37.43,76.6,61.62,111.64,76.99h0c-59.89-28.41-111.42-104.99-89.46-207.21,21.96-102.22,111.3-137.05,139.82-143.79,0,0,94-50,234,38,168.73,106.06,162,272,162,272,0,0,54-132-28-286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m564.58,231.42c-143.3-122.89-353.98-94.5-433.48,15-43.41,59.8-52.38,116.37-51.58,155.41,13.92,24.63,32.52,48.68,55.98,71.48,38.52,37.43,76.6,61.62,111.64,76.99-59.89-28.41-111.42-104.99-89.46-207.21,21.96-102.22,111.3-137.05,139.82-143.79,0,0,94-50,234,38,168.73,106.06,162,272,162,272,2.93-16.09,14.38-155.01-128.92-277.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m413.5,569.31c-.13.04-.27.08-.4.12.27-.08.4-.12.4-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m157.68,343.09c-21.96,102.22,29.57,178.8,89.46,207.21h0c90.07,39.52,160.07,20.82,165.96,19.12.13-.04.27-.08.4-.12,63.7-19.51,146.24-84.62,129.58-216.37,0,0-12.89-109.91-132.93-148.08-64.34-13.84-112.65-5.55-112.65-5.55-28.52,6.74-117.86,41.57-139.82,143.79Zm107.38-81.23c32.83,0,59.44,26.61,59.44,59.44s-26.61,59.44-59.44,59.44-59.44-26.61-59.44-59.44,26.61-59.44,59.44-59.44Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1072.64,223.99v148h259.2v104h-259.2v204h-129.6V119.99h423.2v104h-293.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1377.44,464.79c0-129.6,100-221.6,236.8-221.6s236,92,236,221.6-99.2,221.6-236,221.6-236.8-92-236.8-221.6Zm346.4,0c0-74.4-47.2-119.2-109.6-119.2s-110.4,44.8-110.4,119.2,48,119.2,110.4,119.2,109.6-44.8,109.6-119.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2323.84,249.59l-181.6,430.4h-128.8l-180.8-430.4h128.8l119.2,292.8,123.2-292.8h120Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2757.43,499.99h-325.6c12,53.6,57.6,86.4,123.2,86.4,45.6,0,78.4-13.6,108-41.6l66.4,72c-40,45.6-100,69.6-177.6,69.6-148.8,0-245.6-93.6-245.6-221.6s98.4-221.6,229.6-221.6,224,84.8,224,223.2c0,9.6-1.6,23.2-2.4,33.6Zm-327.2-72.8h212c-8.8-54.4-49.6-89.6-105.6-89.6s-97.6,34.4-106.4,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3187.03,434.39v245.6h-116.8v-53.6c-23.2,39.2-68,60-131.2,60-100.8,0-160.8-56-160.8-130.4s53.6-128.8,184.8-128.8h99.2c0-53.6-32-84.8-99.2-84.8-45.6,0-92.8,15.2-124,40l-44.8-87.2c47.2-33.6,116.8-52,185.6-52,131.2,0,207.2,60.8,207.2,191.2Zm-124.8,109.6v-44h-85.6c-58.4,0-76.8,21.6-76.8,50.4,0,31.2,26.4,52,70.4,52,41.6,0,77.6-19.2,92-58.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3661.42,522.39h-324.8l-71.2,157.6h-44l257.6-560h40.8l257.6,560h-44l-72-157.6Zm-15.2-34.4l-147.2-323.2-146.4,323.2h293.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3854.21,119.99h40.8v560h-40.8V119.99Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoveaaiLogoDarkText);
export default __webpack_public_path__ + "static/media/foveaai_logo_dark_text.c9f1364457dd3e90c11681e9f381e690.svg";
export { ForwardRef as ReactComponent };